
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 180 120"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h180v120H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M0 0h180v80H0z"}}),_c('path',{attrs:{"fill":"#ce1126","d":"M0 0h180v40H0z"}}),_c('g',{attrs:{"id":"d","fill":"#007a3d"}},[_c('g',{attrs:{"id":"c"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"d":"M54 47v13h8","transform":"rotate(18 54 47)","id":"a"}}),_c('use',{attrs:{"xlink:href":"#a","x":"-108","transform":"scale(-1 1)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(72 54 60)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(-72 54 60)"}}),_c('use',{attrs:{"xlink:href":"#c","transform":"rotate(144 54 60)"}})]),_c('use',{attrs:{"xlink:href":"#d","x":"72"}})])
          )
        }
      }
    